import debugLog from '@/debug-log-script-name.js'

$(function() {
  if (location.hash !== '') {
    $(`a[href='${location.hash}']`).tab('show')
  }
  const $tab = $('a[data-toggle="tab"]')
  debugLog($tab, 'briq-tab.js')
  $tab.on('shown.bs.tab', function(e) {
    if (history.pushState) {
      history.pushState(
        null,
        null,
        '#' +
          $(e.target)
            .attr('href')
            .substr(1),
      )
    }
  })

  window.onpopstate = function(e) {
    $(`a[href='${location.hash}']`).tab('show')
  }
})
